'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FloatingLabel_styles = require('../../FloatingLabel.styles-a6386d0a.js');
var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');
var Icons_ShowIcon_index = require('../../Icons/ShowIcon/index.js');
var Icons_HideIcon_index = require('../../Icons/HideIcon/index.js');
var Icons_ValidIcon_index = require('../../Icons/ValidIcon/index.js');
var Icons_CrossIcon_index = require('../../Icons/CrossIcon/index.js');
require('styled-components');
require('../../browser.utils-bfcc05c6.js');
require('../../viewport.utils-0c2b4e2b.js');
require('../../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var InputType = {
    TEXT: 'text',
    PASSWORD: 'password',
};
var ValidationType = {
    UNVERIFIED: 'Unverified',
    ERROR: 'Invalid',
    VALID: 'Valid',
};
var defaultShowPasswordText = {
    showButtonLabel: 'Show password as plain text. Warning: this will display your password on the screen.',
    showButtonHideTitle: 'hide',
    showButtonShowTitle: 'show',
};
var FloatingLabelInput = function (_a) {
    var customId = _a.id, label = _a.label, hint = _a.hint, prefix = _a.prefix, suffix = _a.suffix, isValid = _a.isValid, onBlur = _a.onBlur, onFocus = _a.onFocus, value = _a.value, otherProps = tslib_es6.__rest(_a, ["id", "label", "hint", "prefix", "suffix", "isValid", "onBlur", "onFocus", "value"]);
    var isDisabled = otherProps.disabled, type = otherProps.type, name = otherProps.name;
    var id = customId || "input-id-" + name;
    var _b = React.useState(!!value), active = _b[0], setActive = _b[1];
    var _c = React.useState(false), isPasswordShown = _c[0], setPasswordShown = _c[1];
    var hasShownToggle = type === InputType.PASSWORD;
    var hintId = hint ? id + "_hint" : undefined;
    var describedBy = [otherProps['aria-describedby'], hintId].filter(function (e) { return !!e; }).join(' ');
    React.useEffect(function () {
        var _a;
        var shouldActivate = id === ((_a = document === null || document === void 0 ? void 0 : document.activeElement) === null || _a === void 0 ? void 0 : _a.id) || !!value;
        setActive(shouldActivate);
    }, [value, id]);
    var handleBlur = function (e) {
        var _a;
        var v = value || ((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
        setActive(!!(v && v.length));
        if (onBlur) {
            onBlur(e);
        }
    };
    var handleFocus = function (e) {
        setActive(true);
        if (onFocus) {
            onFocus(e);
        }
    };
    var renderPasswordButton = function (texts) {
        var _a = tslib_es6.__assign(tslib_es6.__assign({}, defaultShowPasswordText), texts), showButtonLabel = _a.showButtonLabel, showButtonHideTitle = _a.showButtonHideTitle, showButtonShowTitle = _a.showButtonShowTitle;
        if (!hasShownToggle) {
            return null;
        }
        var Icon = isPasswordShown ? Icons_HideIcon_index['default'] : Icons_ShowIcon_index['default'];
        var buttonId = id + "_show-button";
        return (React__default['default'].createElement(FloatingLabel_styles.StyledSuffixButton, { id: buttonId, type: "button", "aria-label": showButtonLabel, onClick: function () { return setPasswordShown(!isPasswordShown); }, title: isPasswordShown ? showButtonHideTitle : showButtonShowTitle },
            React__default['default'].createElement(Icon, null)));
    };
    var renderValidation = function () {
        var showIcon = !suffix && !hasShownToggle;
        if (isValid === undefined) {
            return null;
        }
        var validationLabel = isValid ? ValidationType.VALID : ValidationType.ERROR;
        return (React__default['default'].createElement(FloatingLabel_styles.StyledValidation, { isValid: isValid, title: validationLabel }, showIcon && (isValid ? React__default['default'].createElement(Icons_ValidIcon_index['default'], null) : React__default['default'].createElement(Icons_CrossIcon_index['default'], null))));
    };
    var suffixElement = typeof suffix === 'string' ? React__default['default'].createElement(FloatingLabel_styles.StyledTextInfix, null, suffix) : suffix;
    var prefixElement = typeof prefix === 'string' ? React__default['default'].createElement(FloatingLabel_styles.StyledTextInfix, null, prefix) : prefix;
    return (React__default['default'].createElement(FloatingLabel_styles.StyledWrapper, { isActive: active, isDisabled: isDisabled },
        React__default['default'].createElement(FloatingLabel_styles.StyledLabel, { htmlFor: id, isActive: active }, label),
        React__default['default'].createElement(FloatingLabel_styles.StyledInputWrapper, { onBlur: handleBlur, onFocus: handleFocus },
            React__default['default'].createElement(FloatingLabel_styles.StyledLegend, { isActive: active, "aria-hidden": "true" }, label),
            React__default['default'].createElement(FloatingLabel_styles.StyledTextFieldWrapper, null,
                prefix && React__default['default'].createElement(FloatingLabel_styles.StyledPrefix, null, prefixElement),
                React__default['default'].createElement(FloatingLabel_styles.StyledTextField, tslib_es6.__assign({ "aria-describedby": describedBy || undefined }, otherProps, { value: value, id: id, type: isPasswordShown ? InputType.TEXT : type, "aria-invalid": !isValid })),
                React__default['default'].createElement(FloatingLabel_styles.AutofillOverlay, null),
                suffixElement,
                renderPasswordButton(),
                renderValidation())),
        hint && React__default['default'].createElement(FloatingLabel_styles.StyledHints, { id: hintId }, hint)));
};

var Hint = {
    Warning: FloatingLabel_styles.StyledHintWarning,
    Success: FloatingLabel_styles.StyledHintSuccess,
    Error: FloatingLabel_styles.StyledHintError,
};
Hint.Error.displayName = 'Hint.Error';
Hint.Success.displayName = 'Hint.Success';
Hint.Warning.displayName = 'Hint.Warning';

exports.Hint = Hint;
exports.default = FloatingLabelInput;
//# sourceMappingURL=index.js.map
